import axios from 'axios';
import { api } from '../config';
import { store } from '../index';
import { redirectToLogout } from '../slices/thunks';

let authHeaderLoaded = false;

// Configuración existente
axios.defaults.headers.post['Content-Type'] = 'application/json';

// Prevent browser from caching GET responses (ensures refetch always hits the server)
// Skip cache headers for external APIs that block them via CORS (e.g. SPED original API)
axios.interceptors.request.use(function (config) {
	if (config.method === 'get') {
		const externalBaseURLs = [
			api.REACT_APP_SPED_ORIGINAL_API_URL,
			api.REACT_APP_SPED_DATA_PROVIDERS_API_URL,
		].filter(Boolean);
		const isExternal = externalBaseURLs.includes(config.baseURL);
		if (!isExternal) {
			config.headers = config.headers || {};
			config.headers['Cache-Control'] = 'no-cache';
			config.headers['Pragma'] = 'no-cache';
		}
	}
	return config;
});

const token = JSON.parse(localStorage.getItem('authUser'))
	? JSON.parse(localStorage.getItem('authUser')).access_token
	: null;

if (token) axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;

axios.interceptors.response.use(
	function (response) {
		return response.data ? response.data : response;
	},
	function (error) {
		let message;
		switch (error.request.status) {
			case 500:
				message = 'Internal Server Error';
				break;
			case 401:
				authHeaderLoaded = false;
				message = 'Invalid credentials';
				if (store.getState().Login.isUserLogout === false) {
					store.dispatch(redirectToLogout());
				}
				break;
			case 404:
				try {
					const response = JSON.parse(error.request.response);
					message = response?.detail;
				} catch (e) {
					message =
						'Lo sentimos, no pudimos encontrar los datos que estás buscando';
				}
				break;
			default:
				// Try to extract message from response data first
				try {
					const responseData = JSON.parse(error.request.response);
					message =
						responseData?.message ||
						responseData?.detail ||
						error.message ||
						'Error desconocido';
				} catch (e) {
					message = error.message || 'Error desconocido';
				}
		}

		// Create a new error object that preserves the original error structure
		const enhancedError = new Error(message);
		enhancedError.response = error.response;
		enhancedError.request = error.request;
		enhancedError.status = error.request?.status;
		enhancedError.originalError = error;

		return Promise.reject(enhancedError);
	}
);

const setAuthorization = token => {
	axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
	authHeaderLoaded = true;
};

class APIClient {
	constructor(baseURL) {
		this.baseURL = baseURL;
	}

	get = (url, options) => {
		axios.defaults.baseURL = this.baseURL;
		let response;
		if (options != null && Object.keys(options).length > 0) {
			response = axios.get(url, options);
		} else {
			response = axios.get(url);
		}
		return response;
	};

	post = (url, data, options) => {
		axios.defaults.baseURL = this.baseURL;
		if (options != null && Object.keys(options).length > 0) {
			return axios.post(url, data, options);
		} else {
			return axios.post(url, data);
		}
	};

	create = (url, data) => {
		axios.defaults.baseURL = this.baseURL;
		return axios.post(url, data);
	};

	update = (url, data) => {
		axios.defaults.baseURL = this.baseURL;
		return axios.patch(url, data);
	};

	put = (url, data) => {
		axios.defaults.baseURL = this.baseURL;
		return axios.put(url, data);
	};

	delete = (url, config) => {
		axios.defaults.baseURL = this.baseURL;
		return axios.delete(url, { ...config });
	};

	// uploadLogo = (logoData) => {
	//     return axios.post('/api/upload-logo', { logoData });
	// };
}

const getLoggedInUser = () => {
	const user = localStorage.getItem('authUser');
	if (!user) {
		return null;
	} else {
		return JSON.parse(user);
	}
};

export { APIClient, setAuthorization, getLoggedInUser };
